import Bowser from 'bowser'

// 
// Browser detect
// 

const browser_info = Bowser.getParser(window.navigator.userAgent);

// Check mobile device
const is_mobile = browser_info.getPlatformType() === 'mobile'
const is_tablet = browser_info.getPlatformType() === 'tablet'
const is_desktop = window.innerWidth >= 1280;
const is_fhd = window.innerWidth >= 1600 && window.innerWidth <= 1920;
const is_desktop_small = window.innerWidth >= 1280 && window.innerWidth < 1600;

export {
    browser_info,
    is_mobile,
    is_tablet,
    is_desktop,
    is_desktop_small,
    is_fhd
}